var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 221,
    viewBox: "0 0 229 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.6816 15.8096C103.765 1.39656 124.25 1.39707 131.333 15.8105H131.332L154.547 63.0342L206.457 70.6025H206.456C222.322 72.9134 228.6 92.4435 217.165 103.643L217.163 103.644L179.591 140.411L188.459 192.323V192.325C191.15 208.109 174.634 220.242 160.421 212.737V212.736L114.013 188.248L67.5938 212.738L67.5928 212.737C53.3793 220.24 36.8662 208.108 39.5566 192.325V192.323L48.4248 140.411L10.8555 103.646C-0.594272 92.4531 5.70292 72.9293 21.5537 70.6035L21.5586 70.6025L73.4658 63.0342L96.6816 15.8096Z",
    stroke: "#49712B",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteEmpty);
export default __webpack_public_path__ + "static/media/favorite-empty.d70b44b6d0fe4e6ea6d662e6288d6d9d.svg";
export { ForwardRef as ReactComponent };